var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Qualification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 48.38a23.1 23.1 0 10-34.43 0L15.06 59h7.11l3.3 5.55 5.17-9.76a23 23 0 0015.29 0l5.18 9.76L54.4 59h7.11L55.5 48.38zm-2.22-3.92A18.86 18.86 0 1157.19 33a18.92 18.92 0 01-3.91 11.46zM38.29 19A14 14 0 0035 46.59a13.45 13.45 0 006.59 0 14 14 0 009-6.9A14 14 0 0038.29 19zm0 24a10 10 0 110-20 10 10 0 010 20zm4-10a4 4 0 11-8 0 4 4 0 018 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Qualification.89477d96.svg";
export { SvgK1Qualification as ReactComponent };